import json_fi from './locale_fi';

export const Localize = (key) => {
	if (json_fi[key]) {
		return json_fi[key];
	}
	console.warn('no locale for: ' + key);
	return '**** key ****';
};


// WEBPACK FOOTER //
// ./src/locale/localization.js